import api from './index';

export const getCurrentHubId = () => Number(localStorage.getItem('adminId') || 0);

export const formatHubLabel = (hub) => {
  if (!hub) return '';
  const name = hub.name || hub.adminName || `Hub #${hub.adminId}`;
  const city = hub.city ? ` (${hub.city})` : '';
  return `${name}${city}`;
};

const normalizeHub = (hub) => ({
  adminId: Number(hub.adminId ?? hub.id),
  name: hub.name || hub.adminName || '',
  city: hub.city || '',
});

const withCurrentHubFallback = (list) => {
  const currentId = getCurrentHubId();
  if (!currentId || list.some((hub) => hub.adminId === currentId)) {
    return list;
  }

  return [
    {
      adminId: currentId,
      name: localStorage.getItem('name') || `Hub #${currentId}`,
      city: localStorage.getItem('adminCity') || '',
    },
    ...list,
  ];
};

/**
 * Active admin hubs for destination / dispatch pickers.
 * Prefers GET /api/v1/hubs (auth, all active hubs).
 * Falls back to GET /api/v1/admins (public, city-required) if hubs route is unavailable.
 */
export const fetchHubs = async ({ excludeCurrent = false } = {}) => {
  let rows = [];

  try {
    const response = await api.get('/api/v1/hubs');
    rows = response?.data?.hubs || response?.data?.admins || [];
  } catch (error) {
    // Older backends may not expose /hubs yet.
    if (error?.response?.status !== 404) {
      throw error;
    }
    const response = await api.get('/api/v1/admins');
    rows = response?.data?.admins || response?.data?.hubs || [];
  }

  const currentId = getCurrentHubId();
  const hubs = withCurrentHubFallback(
    rows
      .map(normalizeHub)
      .filter((hub) => hub.adminId > 0)
  );

  return hubs.filter((hub) => (excludeCurrent ? hub.adminId !== currentId : true));
};

export default fetchHubs;
